// extracted by mini-css-extract-plugin
export default {"card":"productCard_card__HRDWz","cardImage":"productCard_cardImage__wYaiw","cardButton":"productCard_cardButton__ETnMk","produktNavn":"productCard_produktNavn__M6Jyc"};